/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import Datetime from 'react-datetime';
import moment from 'moment-timezone';

import 'react-datetime/css/react-datetime.css';
import * as S from '../../styles';

export interface IDatePickerProps {
    id: string;
    fontScale?: number;
    isOneYearLimit?: boolean;
    label?: string;
    labelColor?: string;
    errorText?: string;
    value?: string;
    beforeField?: string;
    afterField?: string;
    required?: boolean;
    placeholder?: string;
    readOnly?: boolean;
    timeZone?: string;
    hasError?: boolean;
    isFuture?: boolean;
    isPast?: boolean;
    isPassport?: boolean;
    isAdult?: boolean;
    onCompChange?(id: string, payload: any): void;
    disableFutureDate: boolean;
}

export const DatePicker = ({
    id,
    fontScale,
    isOneYearLimit,
    label,
    labelColor,
    errorText,
    value,
    required,
    placeholder,
    timeZone,
    readOnly,
    hasError,
    onCompChange,
    isFuture,
    isPast,
    isAdult,
    afterField,
    beforeField,
    isPassport,
    disableFutureDate,
}: IDatePickerProps) => {
    const [textValue, setTextValue] = useState(value ?? '');
    const [isInvalid, setInvalid] = useState<any>(false);
    useEffect(() => setTextValue(value ?? ''), [value]);

    useEffect(() => {
        setInvalid(hasError);
    }, [hasError]);

    const onChange = (id: string, e: any) => {
        setTextValue(e);
        onCompChange && onCompChange(id, moment(e).format('YYYY-MM-DD'));
    };

    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel fontScale={fontScale} color={labelColor}>
                    {label}
                    {required && <sup style={{ color: 'red' }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip" fontScale={fontScale}>
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };

    const valid = (x: any) => {
        var today = moment().format('YYYY-MM-DD');
        var currDate = x.format('YYYY-MM-DD');
        console.log('x->', today, currDate, isAdult);
        var currDate1 = x.startOf('day');
        var oneYearFromToday = moment().add(1, 'year').endOf('day'); // One year limit
        // if (isAdult) {
        //     console.log('x->', today, currDate);
        //     var arr = currDate.split('-');
        //     var todayArr = today.split('-');
        //     if (parseInt(todayArr?.[0]) - 18 > parseInt(arr?.[0])) {
        //         console.log('lh->')
        //         return true;
        //     }
        //     if (
        //         parseInt(todayArr?.[0]) - 18 === parseInt(arr?.[0]) &&
        //         parseInt(todayArr?.[1]) > parseInt(arr?.[1])
        //         ) {
        //         console.log('lh->')
        //         return true;
        //     }
        //     if (
        //         parseInt(todayArr?.[0]) - 18 === parseInt(arr?.[0]) &&
        //         parseInt(todayArr?.[1]) === parseInt(arr?.[1]) &&
        //         parseInt(todayArr?.[2]) >= parseInt(arr?.[2])
        //         ) {
        //         console.log('lh->')
        //         return true;
        //     }
        //     return false;
        // }
        console.log('lh->');
        // if (isPassport) {
        //     var todayArr = today.split('-');
        //     let newExpiry = '';
        //     if (parseInt(todayArr?.[1]) + 6 <= 12) {
        //         newExpiry =
        //             todayArr?.[0] +
        //             '-' +
        //             (parseInt(todayArr?.[1]) + 6).toString() +
        //             '-' +
        //             todayArr?.[2];
        //     } //
        //     else {
        //         newExpiry =
        //             (parseInt(todayArr?.[0]) + 1).toString() +
        //             '-0' +
        //             ((parseInt(todayArr?.[1]) + 6) % 12).toString() +
        //             '-' +
        //             todayArr?.[2];
        //     }
        //     console.log('expiry->', newExpiry);
        //     return currDate >= newExpiry;
        // }
        if (isOneYearLimit) {
            return (
                currDate1.isAfter(today) &&
                currDate1.isSameOrBefore(oneYearFromToday)
            );
        }
        if (beforeField) {
            if (isPast) {
                return beforeField > currDate && today > currDate;
            }
            if (isFuture) {
                return beforeField > currDate && today < currDate;
            }
            if (disableFutureDate) {
                return beforeField >= currDate && today >= currDate;
            }
            return beforeField > currDate;
        }
        if (afterField) {
            if (isPast) {
                return afterField < currDate && today > currDate;
            }
            if (isFuture) {
                return afterField < currDate && today < currDate;
            }
            if (disableFutureDate) {
                return afterField <= currDate && today >= currDate;
            }
            return afterField < currDate;
        }

        if (isFuture) {
            return today < currDate;
        }
        if (isPast) {
            return today > currDate;
        }
        if (disableFutureDate) {
            return today >= currDate;
        }
        console.log('lh->');
        return true;
    };
    document.getElementById(`input-${id}`)?.addEventListener('focusin', (e) => {
        console.log(e, 'moi->');
        document
            .getElementById(`input-group-${id}`)
            ?.classList.add('input-group-ch');
    });
    document
        .getElementById(`input-${id}`)
        ?.addEventListener('focusout', (e) => {
            console.log(e, 'moi->');
            document
                .getElementById(`input-group-${id}`)
                ?.classList.remove('input-group-ch');
        });
    return (
        <>
            <Form.Group
                id={id}
                className=" formgroup"
                style={{ backgroundColor: readOnly ? '#F5F5F5' : '#fff' }}
            >
                {_renderLabelIf()}
                <Datetime
                    displayTimeZone={timeZone}
                    timeFormat={false}
                    closeOnSelect={true}
                    isValidDate={valid}
                    dateFormat="DD/MM/YYYY"
                    onChange={onChange.bind(null, id)}
                    renderInput={(props, openCalendar) => (
                        // <InputGroup className="inputcontrol shadow-none">
                        //     <InputGroup.Text>
                        //         <CalendarIcon className="icon icon-xs" />
                        //     </InputGroup.Text>
                        <>
                            <InputGroup
                                id={`input-group-${id}`}
                                className="input-group-bt"
                            >
                                <S.FormControl
                                    fontScale={fontScale}
                                    style={{
                                        backgroundColor: readOnly
                                            ? '#F5F5F5'
                                            : '#fff',
                                    }}
                                    className="formcontrol shadow-none"
                                    required={required}
                                    id={`input-${id}`}
                                    type="text"
                                    value={
                                        textValue
                                            ? timeZone
                                                ? moment
                                                      .tz(textValue, timeZone)
                                                      .format('DD/MM/YYYY')
                                                : moment(textValue)?.format(
                                                      'DD/MM/YYYY'
                                                  )
                                            : ''
                                    }
                                    placeholder="mm/dd/yyyy"
                                    onFocus={openCalendar}
                                    onChange={() => {}}
                                    readOnly={readOnly}
                                    disabled={readOnly}
                                    isInvalid={isInvalid}
                                />
                            </InputGroup>
                            <InputGroup>{_renderErrorTextIf()}</InputGroup>
                        </>
                    )}
                />
            </Form.Group>
        </>
    );
};

DatePicker.defaultProps = {
    required: false,
    readOnly: false,
    hasError: false,
    timeZone: null,
    isOneYearLimit: false,
};
